const Bservices = [
    {
        title: "Planning",
        description: "Comprehensive planning services to provide cost-effective and innovative solutions for your development needs."
    },
    {
        title: "Design",
        description: "Cutting-edge architectural design that balances aesthetics with functionality for modern urban spaces."
    },
    {
        title: "Construction",
        description: "Expert construction management ensuring quality execution and timely delivery of projects."
    },
    {
        title: "Project Management",
        description: "End-to-end project oversight with detailed attention to budgets, timelines, and quality standards."
    }
];

export default Bservices;